import { useEffect, useState } from "react";
import { Toast } from "react-bootstrap";

const ToastMessage = ({ onClose, message, variant = "success"}) => {
  const [show, setShow] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(false);
      onClose?.();
    }, 3000); // Auto-dismiss after 3 seconds
    return () => clearTimeout(timer);
  }, [onClose]);
  return (
      <Toast bg={variant} onClose={onClose} show={show}>
        <Toast.Body className="text-white">{message}</Toast.Body>
      </Toast>
  );
};

export default ToastMessage;